module.exports = __webpack_public_path__ + "img/404.f2d6de1.svg";